import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';
import { VIDEO_SPEEDS } from "../../../constants";
import { useHlsContext } from "../../../context/Hls";
import { usePlaybackContext } from "../../../context/Playback";
import { useUIContext } from "../../../context/UI";
import { useOnWindowClick, useTranslation } from "../../../hooks";
import CC from "./CC";
import Settings from "./Settings";
import { jsx as _jsx } from "react/jsx-runtime";
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-vno5d5-0"
})(["\n  bottom: 68px;\n  left: 50%;\n  ", "\n  &.is-open {\n    visibility: visible;\n    opacity: 1;\n    transition: ", ";\n  }\n  &.is-closed {\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s 150ms,\n      ", ";\n  }\n  & span,\n  button {\n    user-select: none;\n    white-space: nowrap;\n  }\n"], function (_ref) {
  var menuId = _ref.menuId,
    hasQualities = _ref.hasQualities;
  if (menuId === 'settings') {
    return "\n        padding: 16px 0;\n        min-width: 380px;\n        transform: translateX(".concat(hasQualities ? '-70%' : '-78%', ");\n      ");
  }
  return "\n      padding: 24px;\n      min-width: 0;\n      transform: translateX(-50%);\n    ";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition(['opacity', 'transform', 'min-width']);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition(['opacity', 'transform', 'min-width']);
});
var DesktopSheet = function DesktopSheet(_ref4) {
  var selector = _ref4.selector,
    menuId = _ref4.menuId,
    onDismiss = _ref4.onDismiss,
    onSpeedChange = _ref4.onSpeedChange,
    onQualityChange = _ref4.onQualityChange,
    onSubtitlesChange = _ref4.onSubtitlesChange,
    onAudioChange = _ref4.onAudioChange;
  var _usePlaybackContext = usePlaybackContext(),
    currentSpeed = _usePlaybackContext.currentSpeed;
  var _useHlsContext = useHlsContext(),
    qualities = _useHlsContext.qualities,
    currentQuality = _useHlsContext.currentQuality;
  var _useUIContext = useUIContext(),
    activeMenu = _useUIContext.activeMenu;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var containerRef = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    settingsSections = _useState2[0],
    setSettingsSections = _useState2[1];
  var onWindowClick = function onWindowClick(event) {
    if (activeMenu === menuId) {
      var clickedOnMenu = containerRef.current && containerRef.current.contains(event.target);
      var controlButton = document ? document.querySelector(".cp-".concat(menuId, "-btn")) : undefined;
      var clickedOnMenuBtn = controlButton && controlButton.contains(event.target);
      if (!clickedOnMenu && !clickedOnMenuBtn) {
        onDismiss();
      }
    }
  };
  useOnWindowClick(onWindowClick);
  var onBack = function onBack() {
    setSettingsSections(undefined);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (activeMenu === menuId) {
      onBack();
    }
  }, [activeMenu, menuId]);
  var changeSection = function changeSection(newSection) {
    switch (newSection) {
      case 'speed':
        setSettingsSections({
          title: t('SPEED'),
          options: VIDEO_SPEEDS,
          selectedValue: currentSpeed.value,
          onSelect: onSpeedChange
        });
        break;
      case 'quality':
        setSettingsSections({
          title: t('QUALITY'),
          options: qualities,
          selectedValue: currentQuality === null || currentQuality === void 0 ? void 0 : currentQuality.value,
          onSelect: onQualityChange
        });
        break;
      default:
    }
  };
  var node = document.querySelector(selector);
  if (node) {
    return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(Wrapper, {
      className: cn(activeMenu === menuId ? 'is-open' : 'is-closed', 'absolute flex items-start justify-center z-5 bg-base-main-80 rounded-5'),
      menuId: settingsSections ? 'settings-submenu' : menuId,
      hasQualities: !!currentQuality,
      ref: containerRef,
      "data-testid": "cp-menu-desktop-sheet",
      children: menuId === 'cc' ? /*#__PURE__*/_jsx(CC, {
        onSubtitlesChange: onSubtitlesChange,
        onAudioChange: onAudioChange
      }) : /*#__PURE__*/_jsx(Settings, {
        section: settingsSections,
        onBack: onBack,
        changeSection: changeSection
      })
    }), node);
  }
  return null;
};
export default DesktopSheet;